import { render, staticRenderFns } from "./widgetText.vue?vue&type=template&id=49de70ff&scoped=true"
import script from "./widgetText.vue?vue&type=script&lang=js"
export * from "./widgetText.vue?vue&type=script&lang=js"
import style0 from "./widgetText.vue?vue&type=style&index=0&id=49de70ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de70ff",
  null
  
)

export default component.exports